import gButton from "@/components/g-button/g-button";
import gCard from "@/components/g-card/g-card.vue";
import gDateInput from "@/components/g-date-input/g-date-input";
import gForm from "@/components/g-form/g-form";
import gDataTable from "@/components/g-data-table/g-data-table";
import ClienteController from "@/shared/controllers/cliente/clienteController";
import CheckListAmostraController from "@/shared/controllers/checkListAmostraLote/checkListAmostraLoteController";
import ChecklistAmostraLoteViewModel from "@/shared/view-models/ChecklistAmostraLoteViewModel";
import gPdf from "@/components/g-pdf/g-pdf.vue"
import ChecklistAmostraLotePDF from "./PDF/ChecklistAmostraLotePDF.vue";

const name = 'ChecklistAmostraLote'
export default {
  name,
  setup() {
    return {
    }
  },

  components: {
    'g-button': gButton,
    'g-card': gCard,
    'g-date-input': gDateInput,
    'g-form': gForm,
    'g-pdf': gPdf,
    'g-data-table': gDataTable,
    ChecklistAmostraLotePDF
  },

  props: { },


  mounted () {
    this.UnidadeArray = this.$store.state.EmpresaArray;
    this.atualizaEmpresaRepresentante()
    this.mitt.on('trocaEmpresaRepresentante', () => {
      this.atualizaEmpresaRepresentante()
    })
   },

  updated () { },

  data () {
    return {
        pt1: true,
        ChecklistArray: [],
        objFiltros: new ChecklistAmostraLoteViewModel(),
        ClienteArray: [],
        UnidadeArray: [],
        checkListId: null,
        executarvisualizacao: 0,
        renderiza: false,
        Colunas: [
          { field: "formulario", header: "Nº Formulário" },
          { field: "nomeEmpresa", header: "Unidade" },
          { field: "campoCliente", header: "Cliente", width: '350px' },
          { field: "numeroPedido", header: "Pedido" },
          { field: "usuarioNome", header: "Usuário" },
          { field: "dataDigitacaoFormatada", header: "Data digitação" }
        ],
        Filtro: {
          global: { value: null, matchMode: this.filtros.CONTAINS },
          numeroDaSolicitacao: { value: null, matchMode: this.filtros.CONTAINS },
          nomeEmpresa: { value: null, matchMode: this.filtros.CONTAINS },
          campoCliente: { value: null, matchMode: this.filtros.CONTAINS },
          codigoPedido: { value: null, matchMode: this.filtros.CONTAINS },
          dataDigitacaoFormatada: { value: null, matchMode: this.filtros.CONTAINS }
        },
     }
  },

  methods: {
    Grid() {
      this.getLogChecklistLote()
      this.GetChecklistAmostraLote()
    },

    GetChecklistAmostraLote() {
      this.$isLoading(true)
      CheckListAmostraController.GetChecklistAmostraLote(this.objFiltros).requisicao
      .then(response => {
        this.pt1 = false
        this.ChecklistArray = response.data.data || []
      })
      .finally(()=> {
        this.$isLoading(false)
      })
    },

    getLogChecklistLote() {
      this.axios ({
        method: "get",
        url:
          process.env.VUE_APP_WEB_API +
          `ChecklistAmostraLote/getLogChecklistLote/`,
      }).then(() => {
        })
    },

    atualizaEmpresaRepresentante() {
      this.objFiltros.RepresentanteId = this.$store.state.representanteSelecionadoId;
      this.objFiltros.UnidadeId = this.$store.state.empresaSelecionadaId;
    },

    buscarClientes(event){
      window.clearTimeout(this.timer);
      this.timer = setTimeout(() => {
        this.ClienteArray = ClienteController.GetAllClientesByEmpresaIdEFiltro(this.objFiltros.UnidadeId, event).ClientesArray;
      }, 1000);
    },
    gerarPdf(){
      this.executarvisualizacao++
    },
    imprimir(data)
    { 
      this.renderiza = true
      this.checkListId = data.checkListAmostraId
    },
    limpar() {
      this.objFiltros = new ChecklistAmostraLoteViewModel();
      this.ClienteArray = []
      // EmpresaController.getEmpresasAtivas().requisicao
      // .then(response => {
      //   this.UnidadeArray = response.data.data
      //   this.atualizaEmpresaRepresentante()
      // })
      this.mitt.on('trocaEmpresaRepresentante', () => {
        this.atualizaEmpresaRepresentante()
      })
    },
  },

  computed: { },

};